class DisclosuresContent extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      if (event.target.closest('.disclosures-item__content')) return;
      if (
        event.target.closest('.disclosures-item__header') &&
        event.target !== event.target.closest('.disclosures-item__header')
      )
        return;

      const item = event.target.closest('.disclosures-item');
      if (item) {
        const content = item.querySelector('.disclosures-item__content');
        if (content && event.clientX <= content.getBoundingClientRect().right) return;
      }

      const details = this.closest('details');
      if (details) details.removeAttribute('open');
    });
  }

  connectedCallback() {
    this.querySelectorAll('.disclosures-item__content').forEach((content) => {
      this.#linkifyUrls(content);
    });
  }

  // Prop 65 defaults store URLs as plain text, not rich-text link nodes.
  #linkifyUrls(root) {
    const urlPattern = /\bhttps?:\/\/[^\s<>"'()]+/gi;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach((textNode) => {
      if (textNode.parentElement?.closest('a')) return;

      const text = textNode.nodeValue;
      if (!text || !urlPattern.test(text)) return;
      urlPattern.lastIndex = 0;

      const fragment = document.createDocumentFragment();
      let lastIndex = 0;
      let match;

      while ((match = urlPattern.exec(text)) !== null) {
        if (match.index > lastIndex) {
          fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
        }

        const url = match[0].replace(/[.,;:!?)]+$/, '');
        const trailing = match[0].slice(url.length);
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = url;
        fragment.appendChild(link);

        if (trailing) {
          fragment.appendChild(document.createTextNode(trailing));
        }

        lastIndex = match.index + match[0].length;
      }

      if (lastIndex < text.length) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
      }

      textNode.parentNode.replaceChild(fragment, textNode);
    });
  }
}

if (!customElements.get('disclosures-content')) {
  customElements.define('disclosures-content', DisclosuresContent);
}
